export const STATUS_INDICATOR_VARIANTS = {
  CUSTOM: 'custom',
  DEFAULT: 'default',
  INFORMATION: 'information',
  NEGATIVE: 'negative',
  POSITIVE: 'positive',
  WARNING: 'warning',
};
